"use client";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import _styles from "./css/classes.module.css";
import * as _utils from "./utils";
import Block from "./_Builtin/Block";
import Heading from "./_Builtin/Heading";
import HtmlEmbed from "./_Builtin/HtmlEmbed";
import Image from "./_Builtin/Image";
export function MobileHp26WorkflowsV3({ as: _Component = Block, image1 = "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6988ce8cc1b394830bc12508_monday%20workflows%20logo.svg", image2 = "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69c8fb967f56af097773584e_workflows-mb-image.avif", text = "Visually build, automate, and manage complex cross-functional processes with AI.", title1 = "Agentic", title2 = " workflows ", title3 = "that run work end to end", title4 = /*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        "Agentic ",
        " that run work end to end"
    ]
}) }) {
    return /*#__PURE__*/ _jsxs(_Component, {
        className: _utils.cx(_styles, "section_hp-26", "is-workflows"),
        tag: "section",
        children: [
            /*#__PURE__*/ _jsx(Block, {
                className: _utils.cx(_styles, "m_container-large"),
                tag: "div",
                children: /*#__PURE__*/ _jsxs(Block, {
                    className: _utils.cx(_styles, "hp-mb-workflows_component-mb"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ _jsxs(Block, {
                            className: _utils.cx(_styles, "hp_ai-slider-h-wrapper"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ _jsx(Block, {
                                    className: _utils.cx(_styles, "hp_ai-tagline-wrapper"),
                                    tag: "div",
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        alt: "",
                                        className: _utils.cx(_styles, "hp_ai-logo"),
                                        height: "auto",
                                        loading: "lazy",
                                        src: image1,
                                        width: "auto"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(Block, {
                                    className: _utils.cx(_styles, "heading_wrapper-26", "is-workflows"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ _jsx(Heading, {
                                            className: _utils.cx(_styles, "hp_section-title", "is-monday-workflows", "text-style-inline"),
                                            tag: "h2",
                                            children: title1
                                        }),
                                        /*#__PURE__*/ _jsx(Heading, {
                                            className: _utils.cx(_styles, "hp_section-title", "is-monday-workflows", "hp_h-gradient-workflows", "text-style-inline"),
                                            tag: "h2",
                                            children: title2
                                        }),
                                        /*#__PURE__*/ _jsx(Heading, {
                                            className: _utils.cx(_styles, "hp_section-title", "is-monday-workflows", "text-style-inline"),
                                            tag: "h2",
                                            children: title3
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Block, {
                                    className: _utils.cx(_styles, "hide-element"),
                                    tag: "div",
                                    children: /*#__PURE__*/ _jsx(Heading, {
                                        className: _utils.cx(_styles, "hp_section-title", "is-monday-workflows"),
                                        tag: "h2",
                                        children: title4
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Block, {
                                    className: _utils.cx(_styles, "hp_subtitle-wrapper"),
                                    tag: "div",
                                    children: /*#__PURE__*/ _jsx(Block, {
                                        className: _utils.cx(_styles, "hp_subtitle", "is-workflows"),
                                        tag: "div",
                                        children: text
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Block, {
                            className: _utils.cx(_styles, "hp-ai_workflows-image-wrapper"),
                            tag: "div",
                            children: /*#__PURE__*/ _jsx(Image, {
                                alt: "",
                                className: _utils.cx(_styles, "hp-ai_workflows-image"),
                                height: "auto",
                                loading: "lazy",
                                src: image2,
                                width: "auto"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(HtmlEmbed, {
                content: "",
                value: "%3Cstyle%3E%0A%5Bclass*%3D%22hp_h-gradient-workflows%22%5D%20%7B%20%20%0A%20%20background-image%3A%20linear-gradient(45deg%2C%20rgb(58%2C%20201%2C%20255)%2C%20rgb(122%2C%20127%2C%20240))%3B%0A%20%20background-clip%3A%20text%3B%0A%20%20-webkit-text-fill-color%3A%20transparent%3B%0A%7D%0A%3C%2Fstyle%3E"
            })
        ]
    });
}
